function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef, useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ImageFocalpointBase from "./ImageFocalpointBase";
const useStyles = makeStyles(theme => ({
  root: {
    //        backgroundColor: "#333",
    //        color: "white",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  preview: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    //        marginTop: theme.spacing(7),
    marginBottom: theme.spacing(6)
  },
  footer: {
    position: "absolute",
    top: "auto",
    right: 0,
    left: 0,
    bottom: 0,
    paddingTop: theme.spacing(1),
    height: theme.spacing(5)
  },
  description: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "12px",
    textAlign: "center"
  }
}));

const EditImageFocalpoint = (_ref) => {
  let className = _ref.className,
      imageUrl = _ref.imageUrl,
      _ref$imageFocalpoint = _ref.imageFocalpoint,
      imageFocalpoint = _ref$imageFocalpoint === void 0 ? {} : _ref$imageFocalpoint,
      imageCropdata = _ref.imageCropdata,
      imageFilters = _ref.imageFilters,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "imageUrl", "imageFocalpoint", "imageCropdata", "imageFilters", "onChange"]);

  const classes = useStyles();

  const handleChange = imageFocalpoint => {
    onChange && onChange(imageFocalpoint);
  };

  return React.createElement("div", {
    className: className || classes.root
  }, React.createElement("div", {
    className: classes.preview
  }, React.createElement(ImageFocalpointBase, {
    imageUrl: imageUrl,
    imageCropdata: imageCropdata,
    imageFilters: imageFilters,
    imageFocalpoint: imageFocalpoint,
    onChange: handleChange
  })), React.createElement("footer", {
    className: classes.footer
  }, React.createElement(Typography, {
    nowrap: true,
    className: classes.description
  }, "Klikk p\xE5 bildet for \xE5 sette fokuspunkt")));
};

export default EditImageFocalpoint;